const NR_AGENT_CONFIG = {
    init: {
        distributed_tracing: {
            enabled: true,
            cors_use_newrelic_header: true,
            cors_use_tracecontext_headers: true,
            allowed_origins: ["https://www.vistaprint.com"],
        },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ["bam.nr-data.net"] },
    },
    loader_config: {
        accountID: "2429158",
        trustKey: "1106546",
        agentID: "1120320596",
        licenseKey: "NRBR-3dc2673d64039888e8b",
        applicationID: "1120320596"
    },
    info: {
        beacon: "bam.nr-data.net",
        errorBeacon: "bam.nr-data.net",
        licenseKey: "NRBR-3dc2673d64039888e8b",
        applicationID: "1120320596",
        sa: 1
    },
};
async function initNewRelicAgent() {
    // The browser agent can only be used when
    if (typeof window !== "undefined") {
        const { MicroAgent } = await import('../../node_modules/@newrelic/browser-agent/dist/esm/loaders/micro-agent.mjs');
        const agent = new MicroAgent(NR_AGENT_CONFIG);
        agent.start(undefined);
        return agent;
    }
    else {
        return null;
    }
}
// Initialize the browser agent; though this is a promise, by the time any callers actually
// try to use it, it will be defined.
let NR_AGENT;
initNewRelicAgent().then((agent) => (NR_AGENT = agent));
function getNewRelicAgent() {
    return NR_AGENT;
}

export { getNewRelicAgent };
//# sourceMappingURL=newRelic.mjs.map
